import { render, staticRenderFns } from "./verifyCheckinsForm.vue?vue&type=template&id=612a484a&lang=pug&"
import script from "./verifyCheckinsForm.vue?vue&type=script&lang=js&"
export * from "./verifyCheckinsForm.vue?vue&type=script&lang=js&"
import style0 from "./verifyCheckinsForm.vue?vue&type=style&index=0&id=612a484a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports